var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('detail',{attrs:{"data":_vm.data,"extra-info":_vm.extraInfo,"base-info":_vm.baseInfo,"status-module":"server","on-manager":_vm.onManager}})}
var staticRenderFns = []

export { render, staticRenderFns }